import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const searchOrder = async (data = {}, params = {}) => request({
  path: "/search-book",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
